import { render } from "./IconUnknow.vue?vue&type=template&id=32df3d16"
import script from "./IconUnknow.vue?vue&type=script&lang=ts"
export * from "./IconUnknow.vue?vue&type=script&lang=ts"
script.render = render

export default script